import { LibertyBlogSection } from "./liberty/LibertyBlogSection";
import { LibertyOpeningPhasePanel } from "./liberty/LibertyOpeningPhasePanel";
import { OrganizationChapterDirectory } from "./OrganizationChapterDirectory";
import { PublicContactPanel } from "./PublicContactPanel";
import { PublicLeadSection } from "./PublicLeadSection";

export function PublicHomePage({
  campaignAttributionText,
  chapterOrganization,
  eventPluralLabel,
  hasPublicContact,
  leadForm,
  leadSubmitted,
  leadInterestOptions,
  libertyPublic,
  onCreateLead,
  onLeadFormChange,
  publicAddress,
  publicChapters,
  publicContactEmail,
  publicContactPhone,
  publicEventsSection,
  range,
  rangeStory,
  reservationResources,
  slug,
  submittingLead,
  workspaceLabel
}) {
  return (
    <>
      {chapterOrganization ? (
        <>
          <OrganizationChapterDirectory chapters={publicChapters} slug={slug} />
          <section className="public-range-story public-org-story" aria-label="Organization overview">
            {rangeStory.map((item) => (
              <article key={item.title}>
                <strong>{item.title}</strong>
                <span>{item.body}</span>
              </article>
            ))}
          </section>
          {publicEventsSection}
        </>
      ) : !libertyPublic && (
        <>
          <section className="public-range-story" aria-label="Range overview">
            {rangeStory.map((item) => (
              <article key={item.title}>
                <strong>{item.title}</strong>
                <span>{item.body}</span>
              </article>
            ))}
          </section>
          <LibertyOpeningPhasePanel range={range} resources={reservationResources} />
          {publicEventsSection}
        </>
      )}

      {libertyPublic && <LibertyBlogSection />}

      <PublicLeadSection
        attributionText={campaignAttributionText}
        body={libertyPublic
          ? "For membership information please enter your contact information here to be contacted before we open."
          : `Ask for membership timing, openings, or ${eventPluralLabel}. Your request goes straight to the ${workspaceLabel}.`}
        contactEmail={publicContactEmail}
        contactPhone={publicContactPhone}
        form={leadForm}
        interestOptions={leadInterestOptions}
        kicker={libertyPublic ? "Get contacted with updates" : "Opening updates"}
        onChange={onLeadFormChange}
        onSubmit={onCreateLead}
        submitted={leadSubmitted}
        submitting={submittingLead}
        title={libertyPublic ? "Sign up to be notified before we open!" : "Want updates before joining?"}
        workspaceLabel={workspaceLabel}
      />

      {hasPublicContact && !libertyPublic && (
        <PublicContactPanel
          address={publicAddress}
          email={publicContactEmail}
          phone={publicContactPhone}
          workspaceLabel={workspaceLabel}
        />
      )}
    </>
  );
}
